'use strict';

module.exports = {
  template: require('./admin.html'),
  controller: require('./admin.controller')
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/admin/index.js
 ** module id = 165
 ** module chunks = 0
 **/